// extracted by mini-css-extract-plugin
export default {"root":"SuperviseTable_root__hENSy","operation":"SuperviseTable_operation__Ftbfs","stuInfo":"SuperviseTable_stuInfo__iEbbu"};